module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"domain":"Domain","input-1":"Email","input-2":"Password","action":"Sign in","forgot":"Forgot password","without-account":"No account?","register":"Create one"},"pt-BR":{"domain":"Domínio","input-1":"E-mail","input-2":"Senha","action":"Fazer login","forgot":"Esqueci a senha","without-account":"Ainda não tem uma conta?","register":"Registre-se agora!"}}')
  delete Component.options._Ctor
}
